import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useTouchManage from '../../hooks/useTouchManage'

import useStyles from './styles'

function Button(props) {
  const { children, solid = false, primary = false, className, danger, success, colorful, ...restProps } = props
  const classes = useStyles({ colorful })

  const { isTouched, touchStartEvent } = useTouchManage()

  return (
    <button
      onTouchStart={touchStartEvent}
      className={classnames(classes.btn, className, solid ? 'solid' : 'ghost', {
        primary: primary,
        buttonTouched: isTouched,
        danger: danger,
        success: success
      })}
      {...restProps}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  solid: PropTypes.bool,
  danger: PropTypes.bool,
  success: PropTypes.bool,
  // allows to make button text the same color as border
  colorful: PropTypes.bool
}

export default Button
